define([
    'uiComponent',
    'jquery',
    'bootstrap/modal'
], function(Component, $, Modal) {
    'use strict';

    return Component.extend({
        initialize: function(config, element) {
            this._super(config, element);

            if (!element) {
                return;
            }

            $(document).on('ajax:addToCart', function(e, data) {

                // If the minicart is open, do nothing
                if (element.classList.contains('show')) {
                    return;
                }

                // If this event was triggered by the PDP add to cart form, open the modal
                // (as opposed to a quick add form)
                if ("form" in data && typeof data.form.get(0) !== 'undefined' && data.form.get(0).id === 'product_addtocart_form') {
                    var bsModal = new Modal(element, {});
                    bsModal.show();
                }
            });
        }
    });
});
